import operatingCost from '../../fields/cases/operatingCost';

export const QUERY_GET_OC_CASE = /* GraphQL */ `
	query($id: String!) {
		getOperatingCostCase(id: $id) {
			${operatingCost}
		}
	}
`;
